var _defs, _sodipodiNamedview;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDodo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg7245",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    sodipodiDocname: "dodogauche.svg",
    inkscapeVersion: "1.2.2 (732a01da63, 2022-12-09)",
    "inkscapeExport-filename": "dodo.webp",
    "inkscapeExport-xdpi": 96,
    "inkscapeExport-ydpi": 96,
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs7249"
  })), _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview7247",
    pagecolor: "#ffffff",
    bordercolor: "#000000",
    borderopacity: 0.25,
    inkscapeShowpageshadow: 2,
    inkscapePageopacity: 0,
    inkscapePagecheckerboard: "true",
    inkscapeDeskcolor: "#d1d1d1",
    showgrid: "true",
    inkscapeZoom: 9.8263458,
    inkscapeCx: 4.8339435,
    inkscapeCy: 29.207195,
    "inkscapeWindow-width": 1920,
    "inkscapeWindow-height": 1009,
    "inkscapeWindow-x": -8,
    "inkscapeWindow-y": -8,
    "inkscapeWindow-maximized": 1,
    "inkscapeCurrent-layer": "g7251"
  }, /*#__PURE__*/React.createElement("inkscapeGrid", {
    type: "xygrid",
    id: "grid52311"
  }))), /*#__PURE__*/React.createElement("g", {
    inkscapeGroupmode: "layer",
    inkscapeLabel: "Image",
    id: "g7251",
    transform: "matrix(-1,0,0,1,52,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g53425"
  }, /*#__PURE__*/React.createElement("g", {
    id: "use46019",
    transform: "translate(-1,1)",
    style: {
      opacity: 0.984314,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49175",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46021",
    transform: "translate(-1,2)",
    style: {
      opacity: 0.992157,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49179",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46023",
    transform: "translate(-1,3)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49183",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46025",
    transform: "translate(-1,4)",
    style: {
      opacity: 0.984314,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49187",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46047",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49195",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46049",
    transform: "translate(0,1)",
    style: {
      opacity: 0.490196,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49199",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46053",
    transform: "translate(0,5)",
    style: {
      opacity: 0.980392,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49207",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46081",
    transform: "translate(1,-1)",
    style: {
      opacity: 0.988235,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49231",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46083",
    transform: "translate(1)",
    style: {
      opacity: 0.498039,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49235",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46089",
    transform: "translate(1,4)",
    style: {
      opacity: 0.486275,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49247",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46091",
    transform: "translate(1,5)",
    style: {
      opacity: 0.505882,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49251",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46093",
    transform: "translate(1,6)",
    style: {
      opacity: 0.980392,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49255",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46125",
    transform: "translate(2,-1)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49287",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46133",
    transform: "translate(2,3)",
    style: {
      opacity: 0.490196,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49303",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46135",
    transform: "translate(2,4)",
    style: {
      opacity: 0.498039,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49307",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46137",
    transform: "translate(2,5)",
    style: {
      opacity: 0.992157,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49311",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46139",
    transform: "translate(2,6)",
    style: {
      opacity: 0.992157,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49315",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46167",
    transform: "translate(3,-1)",
    style: {
      opacity: 0.992157,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49339",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46171",
    transform: "translate(3,2)",
    style: {
      opacity: 0.505882,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49347",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46173",
    transform: "translate(3,3)",
    style: {
      opacity: 0.498039,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49351",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46175",
    transform: "translate(3,4)",
    style: {
      opacity: 0.988235,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49355",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46177",
    transform: "translate(3,5)",
    style: {
      opacity: 0.498039,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49359",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46179",
    transform: "translate(3,7)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49363",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46213",
    transform: "translate(4,-1)",
    style: {
      opacity: 0.980392,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49399",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46215",
    transform: "translate(4)",
    style: {
      opacity: 0.505882,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49403",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46217",
    transform: "translate(4,1)",
    style: {
      opacity: 0.498039,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49407",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46219",
    transform: "translate(4,2)",
    style: {
      opacity: 0.486275,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49411",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46221",
    transform: "translate(4,3)",
    style: {
      opacity: 0.501961,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49415",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46223",
    transform: "translate(4,4)",
    style: {
      opacity: 0.992157,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49419",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46261",
    transform: "translate(5)",
    style: {
      opacity: 0.988235,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49463",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46263",
    transform: "translate(5,1)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49467",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46265",
    transform: "translate(5,2)",
    style: {
      opacity: 0.992157,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49471",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46267",
    transform: "translate(5,3)",
    style: {
      opacity: 0.988235,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49475",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46269",
    transform: "translate(5,4)",
    style: {
      opacity: 0.988235,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49479",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46301",
    transform: "translate(6,1)",
    style: {
      opacity: 0.984314,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49511",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46303",
    transform: "translate(6,2)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49515",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46305",
    transform: "translate(6,3)",
    style: {
      opacity: 0.988235,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49519",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46307",
    transform: "translate(6,4)",
    style: {
      opacity: 0.980392,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49523",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46351",
    transform: "translate(7,1)",
    style: {
      opacity: 0.984314,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49579",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46353",
    transform: "translate(7,2)",
    style: {
      opacity: 0.988235,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49583",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46355",
    transform: "translate(7,3)",
    style: {
      opacity: 0.984314,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49587",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46357",
    transform: "translate(7,4)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49591",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46359",
    transform: "translate(7,5)",
    style: {
      opacity: 0.980392,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49595",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46361",
    transform: "translate(7,6)",
    style: {
      opacity: 0.992157,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49599",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46371",
    transform: "translate(7,14)",
    style: {
      opacity: 0.498039,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49619",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46373",
    transform: "translate(7,15)",
    style: {
      opacity: 0.980392,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49623",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46375",
    transform: "translate(7,16)",
    style: {
      opacity: 0.980392,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49627",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46377",
    transform: "translate(7,17)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49631",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46379",
    transform: "translate(7,18)",
    style: {
      opacity: 0.984314,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49635",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46381",
    transform: "translate(7,19)",
    style: {
      opacity: 0.992157,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49639",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46383",
    transform: "translate(7,20)",
    style: {
      opacity: 0.988235,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49643",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46401",
    transform: "translate(8)",
    style: {
      opacity: 0.992157,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49647",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46403",
    transform: "translate(8,1)",
    style: {
      opacity: 0.976471,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49651",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46405",
    transform: "translate(8,2)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49655",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46407",
    transform: "translate(8,3)",
    style: {
      opacity: 0.988235,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49659",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46409",
    transform: "translate(8,4)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49663",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46411",
    transform: "translate(8,5)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49667",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46413",
    transform: "translate(8,6)",
    style: {
      opacity: 0.988235,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49671",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46415",
    transform: "translate(8,7)",
    style: {
      opacity: 0.992157,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49675",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46417",
    transform: "translate(8,8)",
    style: {
      opacity: 0.498039,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49679",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46421",
    transform: "translate(8,12)",
    style: {
      opacity: 0.494118,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49687",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46423",
    transform: "translate(8,13)",
    style: {
      opacity: 0.992157,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49691",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46425",
    transform: "translate(8,14)",
    style: {
      opacity: 0.984314,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49695",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46427",
    transform: "translate(8,15)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49699",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46429",
    transform: "translate(8,16)",
    style: {
      opacity: 0.988235,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49703",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46431",
    transform: "translate(8,17)",
    style: {
      opacity: 0.988235,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49707",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46433",
    transform: "translate(8,18)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49711",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46435",
    transform: "translate(8,19)",
    style: {
      opacity: 0.984314,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49715",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46437",
    transform: "translate(8,20)",
    style: {
      opacity: 0.984314,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49719",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46439",
    transform: "translate(8,21)",
    style: {
      opacity: 0.988235,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49723",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46441",
    transform: "translate(8,22)",
    style: {
      opacity: 0.494118,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49727",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46477",
    transform: "translate(9,-1)",
    style: {
      opacity: 0.988235,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49763",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46479",
    transform: "translate(9)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49767",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46481",
    transform: "translate(9,1)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49771",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46483",
    transform: "translate(9,2)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49775",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46485",
    transform: "translate(9,3)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49779",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46487",
    transform: "translate(9,4)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49783",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46489",
    transform: "translate(9,5)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49787",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46491",
    transform: "translate(9,6)",
    style: {
      opacity: 0.988235,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49791",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46493",
    transform: "translate(9,7)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49795",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46495",
    transform: "translate(9,8)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49799",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46497",
    transform: "translate(9,9)",
    style: {
      opacity: 0.984314,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49803",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46499",
    transform: "translate(9,10)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49807",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46501",
    transform: "translate(9,11)",
    style: {
      opacity: 0.968627,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49811",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46503",
    transform: "translate(9,12)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49815",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46505",
    transform: "translate(9,13)",
    style: {
      opacity: 0.992157,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49819",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46507",
    transform: "translate(9,14)",
    style: {
      opacity: 0.988235,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49823",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46509",
    transform: "translate(9,15)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49827",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46511",
    transform: "translate(9,16)",
    style: {
      opacity: 0.992157,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49831",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46513",
    transform: "translate(9,17)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49835",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46515",
    transform: "translate(9,18)",
    style: {
      opacity: 0.992157,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49839",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46517",
    transform: "translate(9,19)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49843",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46519",
    transform: "translate(9,20)",
    style: {
      opacity: 0.988235,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49847",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46521",
    transform: "translate(9,21)",
    style: {
      opacity: 0.984314,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49851",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46523",
    transform: "translate(9,22)",
    style: {
      opacity: 0.980392,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49855",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46525",
    transform: "translate(9,23)",
    style: {
      opacity: 0.509804,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49859",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46557",
    transform: "translate(10,-1)",
    style: {
      opacity: 0.992157,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49891",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46559",
    transform: "translate(10)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49895",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46561",
    transform: "translate(10,1)",
    style: {
      opacity: 0.976471,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49899",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46563",
    transform: "translate(10,2)",
    style: {
      opacity: 0.509804,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49903",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46565",
    transform: "translate(10,3)",
    style: {
      opacity: 0.988235,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49907",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46567",
    transform: "translate(10,4)",
    style: {
      opacity: 0.984314,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49911",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46569",
    transform: "translate(10,5)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49915",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46571",
    transform: "translate(10,6)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49919",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46573",
    transform: "translate(10,7)",
    style: {
      opacity: 0.984314,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49923",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46575",
    transform: "translate(10,8)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49927",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46577",
    transform: "translate(10,9)",
    style: {
      opacity: 0.988235,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49931",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46579",
    transform: "translate(10,10)",
    style: {
      opacity: 0.992157,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49935",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46581",
    transform: "translate(10,11)",
    style: {
      opacity: 0.988235,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49939",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46583",
    transform: "translate(10,12)",
    style: {
      opacity: 0.984314,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49943",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46585",
    transform: "translate(10,13)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49947",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46587",
    transform: "translate(10,14)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49951",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46589",
    transform: "translate(10,15)",
    style: {
      opacity: 0.984314,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49955",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46591",
    transform: "translate(10,16)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49959",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46593",
    transform: "translate(10,17)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49963",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46595",
    transform: "translate(10,18)",
    style: {
      opacity: 0.988235,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49967",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46597",
    transform: "translate(10,19)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49971",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46599",
    transform: "translate(10,20)",
    style: {
      opacity: 0.992157,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49975",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46601",
    transform: "translate(10,21)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49979",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46603",
    transform: "translate(10,22)",
    style: {
      opacity: 0.988235,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49983",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46605",
    transform: "translate(10,23)",
    style: {
      opacity: 0.980392,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49987",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46607",
    transform: "translate(10,24)",
    style: {
      opacity: 0.498039,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect49991",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46623",
    transform: "translate(10,36)",
    style: {
      opacity: 0.486275,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50023",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46645",
    transform: "translate(11,-1)",
    style: {
      opacity: 0.984314,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50031",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46647",
    transform: "translate(11)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50035",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46649",
    transform: "translate(11,1)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50039",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46653",
    transform: "translate(11,3)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50047",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46655",
    transform: "translate(11,4)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50051",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46657",
    transform: "translate(11,5)",
    style: {
      opacity: 0.976471,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50055",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46659",
    transform: "translate(11,6)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50059",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46661",
    transform: "translate(11,7)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50063",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46663",
    transform: "translate(11,8)",
    style: {
      opacity: 0.992157,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50067",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46665",
    transform: "translate(11,9)",
    style: {
      opacity: 0.988235,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50071",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46667",
    transform: "translate(11,10)",
    style: {
      opacity: 0.984314,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50075",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46669",
    transform: "translate(11,11)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50079",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46671",
    transform: "translate(11,12)",
    style: {
      opacity: 0.988235,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50083",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46673",
    transform: "translate(11,13)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50087",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46675",
    transform: "translate(11,14)",
    style: {
      opacity: 0.988235,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50091",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46677",
    transform: "translate(11,15)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50095",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46679",
    transform: "translate(11,16)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50099",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46681",
    transform: "translate(11,17)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50103",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46683",
    transform: "translate(11,18)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50107",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46685",
    transform: "translate(11,19)",
    style: {
      opacity: 0.984314,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50111",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46687",
    transform: "translate(11,20)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50115",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46689",
    transform: "translate(11,21)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50119",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46691",
    transform: "translate(11,22)",
    style: {
      opacity: 0.984314,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50123",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46693",
    transform: "translate(11,23)",
    style: {
      opacity: 0.992157,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50127",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46695",
    transform: "translate(11,24)",
    style: {
      opacity: 0.972549,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50131",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46697",
    transform: "translate(11,25)",
    style: {
      opacity: 0.498039,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50135",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46707",
    transform: "translate(11,36)",
    style: {
      opacity: 0.498039,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50155",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46727",
    transform: "translate(12,-1)",
    style: {
      opacity: 0.984314,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50159",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46729",
    transform: "translate(12)",
    style: {
      opacity: 0.984314,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50163",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46731",
    transform: "translate(12,1)",
    style: {
      opacity: 0.988235,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50167",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46733",
    transform: "translate(12,2)",
    style: {
      opacity: 0.992157,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50171",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46735",
    transform: "translate(12,3)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50175",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46737",
    transform: "translate(12,4)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50179",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46739",
    transform: "translate(12,5)",
    style: {
      opacity: 0.992157,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50183",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46741",
    transform: "translate(12,6)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50187",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46743",
    transform: "translate(12,7)",
    style: {
      opacity: 0.992157,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50191",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46745",
    transform: "translate(12,8)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50195",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46747",
    transform: "translate(12,9)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50199",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46749",
    transform: "translate(12,10)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50203",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46751",
    transform: "translate(12,11)",
    style: {
      opacity: 0.988235,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50207",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46753",
    transform: "translate(12,12)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50211",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46755",
    transform: "translate(12,13)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50215",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46757",
    transform: "translate(12,14)",
    style: {
      opacity: 0.992157,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50219",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46759",
    transform: "translate(12,15)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50223",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46761",
    transform: "translate(12,16)",
    style: {
      opacity: 0.992157,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50227",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46763",
    transform: "translate(12,17)",
    style: {
      opacity: 0.992157,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50231",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46765",
    transform: "translate(12,19)",
    style: {
      opacity: 0.505882,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50235",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46767",
    transform: "translate(12,20)",
    style: {
      opacity: 0.988235,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50239",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46769",
    transform: "translate(12,21)",
    style: {
      opacity: 0.988235,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50243",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46771",
    transform: "translate(12,22)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50247",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46773",
    transform: "translate(12,23)",
    style: {
      opacity: 0.984314,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50251",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46775",
    transform: "translate(12,24)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50255",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46777",
    transform: "translate(12,25)",
    style: {
      opacity: 0.980392,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50259",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46789",
    transform: "translate(12,35)",
    style: {
      opacity: 0.501961,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50283",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46791",
    transform: "translate(12,36)",
    style: {
      opacity: 0.988235,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50287",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46813",
    transform: "translate(13,-1)",
    style: {
      opacity: 0.992157,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50295",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46815",
    transform: "translate(13)",
    style: {
      opacity: 0.992157,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50299",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46817",
    transform: "translate(13,1)",
    style: {
      opacity: 0.980392,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50303",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46819",
    transform: "translate(13,2)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50307",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46821",
    transform: "translate(13,3)",
    style: {
      opacity: 0.988235,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50311",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46823",
    transform: "translate(13,4)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50315",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46825",
    transform: "translate(13,5)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50319",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46827",
    transform: "translate(13,6)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50323",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46829",
    transform: "translate(13,7)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50327",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46831",
    transform: "translate(13,8)",
    style: {
      opacity: 0.984314,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50331",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46833",
    transform: "translate(13,9)",
    style: {
      opacity: 0.988235,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50335",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46835",
    transform: "translate(13,10)",
    style: {
      opacity: 0.976471,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50339",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46839",
    transform: "translate(13,12)",
    style: {
      opacity: 0.984314,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50347",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46841",
    transform: "translate(13,13)",
    style: {
      opacity: 0.984314,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50351",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46843",
    transform: "translate(13,14)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50355",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46845",
    transform: "translate(13,15)",
    style: {
      opacity: 0.992157,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50359",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46847",
    transform: "translate(13,16)",
    style: {
      opacity: 0.992157,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50363",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46849",
    transform: "translate(13,17)",
    style: {
      opacity: 0.505882,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50367",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46857",
    transform: "translate(13,22)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50383",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46859",
    transform: "translate(13,23)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50387",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46861",
    transform: "translate(13,24)",
    style: {
      opacity: 0.988235,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50391",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46863",
    transform: "translate(13,25)",
    style: {
      opacity: 0.988235,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50395",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46865",
    transform: "translate(13,26)",
    style: {
      opacity: 0.992157,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50399",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46873",
    transform: "translate(13,34)",
    style: {
      opacity: 0.47451,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50415",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46875",
    transform: "translate(13,35)",
    style: {
      opacity: 0.992157,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50419",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46877",
    transform: "translate(13,36)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50423",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46899",
    transform: "translate(14,-1)",
    style: {
      opacity: 0.988235,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50427",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46901",
    transform: "translate(14)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50431",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46903",
    transform: "translate(14,1)",
    style: {
      opacity: 0.992157,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50435",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46905",
    transform: "translate(14,2)",
    style: {
      opacity: 0.988235,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50439",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46907",
    transform: "translate(14,3)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50443",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46909",
    transform: "translate(14,4)",
    style: {
      opacity: 0.992157,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50447",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46911",
    transform: "translate(14,5)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50451",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46913",
    transform: "translate(14,6)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50455",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46915",
    transform: "translate(14,7)",
    style: {
      opacity: 0.992157,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50459",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46917",
    transform: "translate(14,8)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50463",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46919",
    transform: "translate(14,9)",
    style: {
      opacity: 0.984314,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50467",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46925",
    transform: "translate(14,13)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50479",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46927",
    transform: "translate(14,14)",
    style: {
      opacity: 0.992157,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50483",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46929",
    transform: "translate(14,15)",
    style: {
      opacity: 0.992157,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50487",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46931",
    transform: "translate(14,16)",
    style: {
      opacity: 0.498039,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50491",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46933",
    transform: "translate(14,17)",
    style: {
      opacity: 0.513725,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50495",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46935",
    transform: "translate(14,18)",
    style: {
      opacity: 0.972549,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50499",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46937",
    transform: "translate(14,19)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50503",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46939",
    transform: "translate(14,20)",
    style: {
      opacity: 0.494118,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50507",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46945",
    transform: "translate(14,23)",
    style: {
      opacity: 0.992157,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50519",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46947",
    transform: "translate(14,24)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50523",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46949",
    transform: "translate(14,25)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50527",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46951",
    transform: "translate(14,26)",
    style: {
      opacity: 0.988235,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50531",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46963",
    transform: "translate(14,34)",
    style: {
      opacity: 0.992157,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50555",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46965",
    transform: "translate(14,35)",
    style: {
      opacity: 0.992157,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50559",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46987",
    transform: "translate(15)",
    style: {
      opacity: 0.980392,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50567",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46989",
    transform: "translate(15,1)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50571",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46991",
    transform: "translate(15,2)",
    style: {
      opacity: 0.988235,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50575",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46993",
    transform: "translate(15,3)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50579",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46995",
    transform: "translate(15,4)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50583",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46997",
    transform: "translate(15,5)",
    style: {
      opacity: 0.984314,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50587",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use46999",
    transform: "translate(15,6)",
    style: {
      opacity: 0.980392,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50591",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47001",
    transform: "translate(15,7)",
    style: {
      opacity: 0.992157,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50595",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47009",
    transform: "translate(15,12)",
    style: {
      opacity: 0.988235,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50611",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47011",
    transform: "translate(15,13)",
    style: {
      opacity: 0.992157,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50615",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47013",
    transform: "translate(15,14)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50619",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47015",
    transform: "translate(15,15)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50623",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47017",
    transform: "translate(15,16)",
    style: {
      opacity: 0.992157,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50627",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47019",
    transform: "translate(15,17)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50631",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47021",
    transform: "translate(15,18)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50635",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47023",
    transform: "translate(15,19)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50639",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47025",
    transform: "translate(15,20)",
    style: {
      opacity: 0.992157,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50643",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47027",
    transform: "translate(15,21)",
    style: {
      opacity: 0.501961,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50647",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47031",
    transform: "translate(15,23)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50655",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47033",
    transform: "translate(15,24)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50659",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47035",
    transform: "translate(15,25)",
    style: {
      opacity: 0.988235,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50663",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47037",
    transform: "translate(15,26)",
    style: {
      opacity: 0.984314,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50667",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47039",
    transform: "translate(15,27)",
    style: {
      opacity: 0.498039,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50671",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47041",
    transform: "translate(15,34)",
    style: {
      opacity: 0.992157,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50675",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47043",
    transform: "translate(15,35)",
    style: {
      opacity: 0.988235,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50679",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47045",
    transform: "translate(15,36)",
    style: {
      opacity: 0.494118,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50683",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47067",
    transform: "translate(16,1)",
    style: {
      opacity: 0.984314,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50691",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47069",
    transform: "translate(16,2)",
    style: {
      opacity: 0.988235,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50695",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47071",
    transform: "translate(16,3)",
    style: {
      opacity: 0.988235,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50699",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47073",
    transform: "translate(16,4)",
    style: {
      opacity: 0.988235,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50703",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47075",
    transform: "translate(16,5)",
    style: {
      opacity: 0.988235,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50707",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47077",
    transform: "translate(16,6)",
    style: {
      opacity: 0.984314,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50711",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47079",
    transform: "translate(16,11)",
    style: {
      opacity: 0.988235,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50715",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47081",
    transform: "translate(16,12)",
    style: {
      opacity: 0.992157,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50719",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47083",
    transform: "translate(16,13)",
    style: {
      opacity: 0.988235,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50723",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47085",
    transform: "translate(16,14)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50727",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47087",
    transform: "translate(16,15)",
    style: {
      opacity: 0.992157,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50731",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47089",
    transform: "translate(16,16)",
    style: {
      opacity: 0.988235,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50735",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47091",
    transform: "translate(16,17)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50739",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47093",
    transform: "translate(16,18)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50743",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47095",
    transform: "translate(16,19)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50747",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47097",
    transform: "translate(16,20)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50751",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47099",
    transform: "translate(16,21)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50755",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47103",
    transform: "translate(16,23)",
    style: {
      opacity: 0.992157,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50763",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47105",
    transform: "translate(16,24)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50767",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47107",
    transform: "translate(16,25)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50771",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47109",
    transform: "translate(16,26)",
    style: {
      opacity: 0.984314,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50775",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47111",
    transform: "translate(16,27)",
    style: {
      opacity: 0.501961,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50779",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47119",
    transform: "translate(16,34)",
    style: {
      opacity: 0.498039,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50795",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47121",
    transform: "translate(16,35)",
    style: {
      opacity: 0.988235,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50799",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47123",
    transform: "translate(16,36)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50803",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47153",
    transform: "translate(17,11)",
    style: {
      opacity: 0.988235,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50831",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47155",
    transform: "translate(17,12)",
    style: {
      opacity: 0.984314,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50835",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47157",
    transform: "translate(17,13)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50839",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47159",
    transform: "translate(17,14)",
    style: {
      opacity: 0.984314,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50843",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47161",
    transform: "translate(17,15)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50847",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47163",
    transform: "translate(17,16)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50851",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47165",
    transform: "translate(17,17)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50855",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47167",
    transform: "translate(17,18)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50859",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47169",
    transform: "translate(17,19)",
    style: {
      opacity: 0.984314,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50863",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47171",
    transform: "translate(17,20)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50867",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47173",
    transform: "translate(17,21)",
    style: {
      opacity: 0.980392,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50871",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47175",
    transform: "translate(17,22)",
    style: {
      opacity: 0.494118,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50875",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47179",
    transform: "translate(17,24)",
    style: {
      opacity: 0.984314,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50883",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47181",
    transform: "translate(17,25)",
    style: {
      opacity: 0.988235,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50887",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47183",
    transform: "translate(17,26)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50891",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47185",
    transform: "translate(17,27)",
    style: {
      opacity: 0.494118,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50895",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47187",
    transform: "translate(17,28)",
    style: {
      opacity: 0.505882,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50899",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47191",
    transform: "translate(17,33)",
    style: {
      opacity: 0.498039,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50907",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47193",
    transform: "translate(17,34)",
    style: {
      opacity: 0.490196,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50911",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47195",
    transform: "translate(17,35)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50915",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47197",
    transform: "translate(17,36)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50919",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47219",
    transform: "translate(18,11)",
    style: {
      opacity: 0.992157,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50923",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47221",
    transform: "translate(18,12)",
    style: {
      opacity: 0.988235,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50927",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47223",
    transform: "translate(18,13)",
    style: {
      opacity: 0.988235,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50931",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47225",
    transform: "translate(18,14)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50935",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47227",
    transform: "translate(18,15)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50939",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47229",
    transform: "translate(18,16)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50943",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47231",
    transform: "translate(18,17)",
    style: {
      opacity: 0.984314,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50947",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47233",
    transform: "translate(18,18)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50951",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47235",
    transform: "translate(18,19)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50955",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47237",
    transform: "translate(18,20)",
    style: {
      opacity: 0.498039,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50959",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47239",
    transform: "translate(18,21)",
    style: {
      opacity: 0.992157,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50963",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47241",
    transform: "translate(18,22)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50967",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47245",
    transform: "translate(18,24)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50975",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47247",
    transform: "translate(18,25)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50979",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47249",
    transform: "translate(18,26)",
    style: {
      opacity: 0.988235,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50983",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47251",
    transform: "translate(18,27)",
    style: {
      opacity: 0.992157,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50987",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47253",
    transform: "translate(18,28)",
    style: {
      opacity: 0.494118,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50991",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47255",
    transform: "translate(18,29)",
    style: {
      opacity: 0.501961,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect50995",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47259",
    transform: "translate(18,33)",
    style: {
      opacity: 0.501961,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51003",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47261",
    transform: "translate(18,34)",
    style: {
      opacity: 0.984314,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51007",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47263",
    transform: "translate(18,35)",
    style: {
      opacity: 0.992157,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51011",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47265",
    transform: "translate(18,36)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51015",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47291",
    transform: "translate(19,11)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51027",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47293",
    transform: "translate(19,12)",
    style: {
      opacity: 0.984314,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51031",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47295",
    transform: "translate(19,13)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51035",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47297",
    transform: "translate(19,14)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51039",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47299",
    transform: "translate(19,15)",
    style: {
      opacity: 0.988235,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51043",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47301",
    transform: "translate(19,16)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51047",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47303",
    transform: "translate(19,17)",
    style: {
      opacity: 0.988235,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51051",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47305",
    transform: "translate(19,18)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51055",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47307",
    transform: "translate(19,19)",
    style: {
      opacity: 0.992157,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51059",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47309",
    transform: "translate(19,20)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51063",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47311",
    transform: "translate(19,21)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51067",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47313",
    transform: "translate(19,22)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51071",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47317",
    transform: "translate(19,24)",
    style: {
      opacity: 0.992157,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51079",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47319",
    transform: "translate(19,25)",
    style: {
      opacity: 0.992157,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51083",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47321",
    transform: "translate(19,26)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51087",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47323",
    transform: "translate(19,27)",
    style: {
      opacity: 0.992157,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51091",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47325",
    transform: "translate(19,28)",
    style: {
      opacity: 0.494118,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51095",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47327",
    transform: "translate(19,29)",
    style: {
      opacity: 0.490196,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51099",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47331",
    transform: "translate(19,32)",
    style: {
      opacity: 0.498039,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51107",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47333",
    transform: "translate(19,33)",
    style: {
      opacity: 0.498039,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51111",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47335",
    transform: "translate(19,34)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51115",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47337",
    transform: "translate(19,35)",
    style: {
      opacity: 0.988235,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51119",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47339",
    transform: "translate(19,36)",
    style: {
      opacity: 0.992157,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51123",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47375",
    transform: "translate(20,11)",
    style: {
      opacity: 0.984314,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51135",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47377",
    transform: "translate(20,12)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51139",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47379",
    transform: "translate(20,13)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51143",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47381",
    transform: "translate(20,14)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51147",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47383",
    transform: "translate(20,15)",
    style: {
      opacity: 0.984314,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51151",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47385",
    transform: "translate(20,16)",
    style: {
      opacity: 0.992157,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51155",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47387",
    transform: "translate(20,17)",
    style: {
      opacity: 0.992157,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51159",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47389",
    transform: "translate(20,18)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51163",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47391",
    transform: "translate(20,19)",
    style: {
      opacity: 0.992157,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51167",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47395",
    transform: "translate(20,21)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51175",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47397",
    transform: "translate(20,22)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51179",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47401",
    transform: "translate(20,24)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51187",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47403",
    transform: "translate(20,25)",
    style: {
      opacity: 0.992157,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51191",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47405",
    transform: "translate(20,26)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51195",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47407",
    transform: "translate(20,27)",
    style: {
      opacity: 0.988235,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51199",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47409",
    transform: "translate(20,28)",
    style: {
      opacity: 0.988235,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51203",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47411",
    transform: "translate(20,29)",
    style: {
      opacity: 0.494118,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51207",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47413",
    transform: "translate(20,30)",
    style: {
      opacity: 0.498039,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51211",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47415",
    transform: "translate(20,31)",
    style: {
      opacity: 0.498039,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51215",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47417",
    transform: "translate(20,32)",
    style: {
      opacity: 0.498039,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51219",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47419",
    transform: "translate(20,33)",
    style: {
      opacity: 0.984314,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51223",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47421",
    transform: "translate(20,34)",
    style: {
      opacity: 0.984314,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51227",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47423",
    transform: "translate(20,35)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51231",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47425",
    transform: "translate(20,36)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51235",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47457",
    transform: "translate(21,11)",
    style: {
      opacity: 0.976471,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51255",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47459",
    transform: "translate(21,12)",
    style: {
      opacity: 0.984314,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51259",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47461",
    transform: "translate(21,13)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51263",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47463",
    transform: "translate(21,14)",
    style: {
      opacity: 0.992157,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51267",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47465",
    transform: "translate(21,15)",
    style: {
      opacity: 0.992157,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51271",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47467",
    transform: "translate(21,16)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51275",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47469",
    transform: "translate(21,17)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51279",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47471",
    transform: "translate(21,18)",
    style: {
      opacity: 0.976471,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51283",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47473",
    transform: "translate(21,19)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51287",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47477",
    transform: "translate(21,21)",
    style: {
      opacity: 0.984314,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51295",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47479",
    transform: "translate(21,22)",
    style: {
      opacity: 0.501961,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51299",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47483",
    transform: "translate(21,24)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51307",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47485",
    transform: "translate(21,25)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51311",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47487",
    transform: "translate(21,26)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51315",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47489",
    transform: "translate(21,27)",
    style: {
      opacity: 0.984314,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51319",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47491",
    transform: "translate(21,28)",
    style: {
      opacity: 0.988235,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51323",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47493",
    transform: "translate(21,29)",
    style: {
      opacity: 0.498039,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51327",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47495",
    transform: "translate(21,30)",
    style: {
      opacity: 0.498039,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51331",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47497",
    transform: "translate(21,31)",
    style: {
      opacity: 0.486275,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51335",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47499",
    transform: "translate(21,32)",
    style: {
      opacity: 0.984314,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51339",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47501",
    transform: "translate(21,33)",
    style: {
      opacity: 0.988235,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51343",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47505",
    transform: "translate(21,35)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51351",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47507",
    transform: "translate(21,36)",
    style: {
      opacity: 0.980392,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51355",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47535",
    transform: "translate(22,11)",
    style: {
      opacity: 0.992157,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51367",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47537",
    transform: "translate(22,12)",
    style: {
      opacity: 0.992157,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51371",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47539",
    transform: "translate(22,13)",
    style: {
      opacity: 0.988235,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51375",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47541",
    transform: "translate(22,14)",
    style: {
      opacity: 0.984314,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51379",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47543",
    transform: "translate(22,15)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51383",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47545",
    transform: "translate(22,16)",
    style: {
      opacity: 0.988235,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51387",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47547",
    transform: "translate(22,17)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51391",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47549",
    transform: "translate(22,18)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51395",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47551",
    transform: "translate(22,19)",
    style: {
      opacity: 0.501961,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51399",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47553",
    transform: "translate(22,21)",
    style: {
      opacity: 0.501961,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51403",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47557",
    transform: "translate(22,23)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51411",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47559",
    transform: "translate(22,24)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51415",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47561",
    transform: "translate(22,25)",
    style: {
      opacity: 0.992157,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51419",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47563",
    transform: "translate(22,26)",
    style: {
      opacity: 0.988235,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51423",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47565",
    transform: "translate(22,27)",
    style: {
      opacity: 0.980392,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51427",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47567",
    transform: "translate(22,28)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51431",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47569",
    transform: "translate(22,29)",
    style: {
      opacity: 0.984314,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51435",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47571",
    transform: "translate(22,31)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51439",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47573",
    transform: "translate(22,32)",
    style: {
      opacity: 0.992157,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51443",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47577",
    transform: "translate(22,36)",
    style: {
      opacity: 0.992157,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51451",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47599",
    transform: "translate(23,12)",
    style: {
      opacity: 0.984314,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51459",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47601",
    transform: "translate(23,13)",
    style: {
      opacity: 0.992157,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51463",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47603",
    transform: "translate(23,14)",
    style: {
      opacity: 0.980392,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51467",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47605",
    transform: "translate(23,15)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51471",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47607",
    transform: "translate(23,16)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51475",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47611",
    transform: "translate(23,18)",
    style: {
      opacity: 0.486275,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51483",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47613",
    transform: "translate(23,19)",
    style: {
      opacity: 0.494118,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51487",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47619",
    transform: "translate(23,22)",
    style: {
      opacity: 0.992157,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51499",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47621",
    transform: "translate(23,23)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51503",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47623",
    transform: "translate(23,24)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51507",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47625",
    transform: "translate(23,25)",
    style: {
      opacity: 0.984314,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51511",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47627",
    transform: "translate(23,26)",
    style: {
      opacity: 0.992157,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51515",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47631",
    transform: "translate(23,28)",
    style: {
      opacity: 0.992157,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51523",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47633",
    transform: "translate(23,29)",
    style: {
      opacity: 0.984314,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51527",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47635",
    transform: "translate(23,30)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51531",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47637",
    transform: "translate(23,31)",
    style: {
      opacity: 0.984314,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51535",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47667",
    transform: "translate(24,13)",
    style: {
      opacity: 0.984314,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51563",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47669",
    transform: "translate(24,14)",
    style: {
      opacity: 0.992157,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51567",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47671",
    transform: "translate(24,15)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51571",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47673",
    transform: "translate(24,16)",
    style: {
      opacity: 0.992157,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51575",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47675",
    transform: "translate(24,17)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51579",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47681",
    transform: "translate(24,20)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51591",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47683",
    transform: "translate(24,21)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51595",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47685",
    transform: "translate(24,22)",
    style: {
      opacity: 0.992157,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51599",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47687",
    transform: "translate(24,23)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51603",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47689",
    transform: "translate(24,24)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51607",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47691",
    transform: "translate(24,25)",
    style: {
      opacity: 0.988235,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51611",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47693",
    transform: "translate(24,26)",
    style: {
      opacity: 0.984314,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51615",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47697",
    transform: "translate(24,29)",
    style: {
      opacity: 0.984314,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51623",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47699",
    transform: "translate(24,30)",
    style: {
      opacity: 0.992157,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51627",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47723",
    transform: "translate(25,14)",
    style: {
      opacity: 0.992157,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51643",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47725",
    transform: "translate(25,15)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51647",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47727",
    transform: "translate(25,16)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51651",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47729",
    transform: "translate(25,17)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51655",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47731",
    transform: "translate(25,18)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51659",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47733",
    transform: "translate(25,19)",
    style: {
      opacity: 0.992157,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51663",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47735",
    transform: "translate(25,20)",
    style: {
      opacity: 0.984314,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51667",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47737",
    transform: "translate(25,21)",
    style: {
      opacity: 0.988235,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51671",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47739",
    transform: "translate(25,22)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51675",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47741",
    transform: "translate(25,23)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51679",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47743",
    transform: "translate(25,24)",
    style: {
      opacity: 0.984314,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51683",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47745",
    transform: "translate(25,25)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51687",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47773",
    transform: "translate(26,14)",
    style: {
      opacity: 0.482353,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51711",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47775",
    transform: "translate(26,15)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51715",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47777",
    transform: "translate(26,16)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51719",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47779",
    transform: "translate(26,17)",
    style: {
      opacity: 0.984314,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51723",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47781",
    transform: "translate(26,18)",
    style: {
      opacity: 0.988235,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51727",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47783",
    transform: "translate(26,19)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51731",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47785",
    transform: "translate(26,20)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51735",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47787",
    transform: "translate(26,21)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51739",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47789",
    transform: "translate(26,22)",
    style: {
      opacity: 0.992157,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51743",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47791",
    transform: "translate(26,23)",
    style: {
      opacity: 0.988235,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51747",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47793",
    transform: "translate(26,24)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51751",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47817",
    transform: "translate(27,11)",
    style: {
      opacity: 0.988235,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51767",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47819",
    transform: "translate(27,12)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51771",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47821",
    transform: "translate(27,13)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51775",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47823",
    transform: "translate(27,14)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51779",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47825",
    transform: "translate(27,15)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51783",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47827",
    transform: "translate(27,16)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51787",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47829",
    transform: "translate(27,17)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51791",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47831",
    transform: "translate(27,18)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51795",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47833",
    transform: "translate(27,19)",
    style: {
      opacity: 0.984314,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51799",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47835",
    transform: "translate(27,20)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51803",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47837",
    transform: "translate(27,21)",
    style: {
      opacity: 0.992157,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51807",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47839",
    transform: "translate(27,22)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51811",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47841",
    transform: "translate(27,23)",
    style: {
      opacity: 0.984314,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51815",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47865",
    transform: "translate(28,10)",
    style: {
      opacity: 0.992157,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51831",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47867",
    transform: "translate(28,11)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51835",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47869",
    transform: "translate(28,12)",
    style: {
      opacity: 0.988235,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51839",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47871",
    transform: "translate(28,13)",
    style: {
      opacity: 0.988235,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51843",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47873",
    transform: "translate(28,14)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51847",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47875",
    transform: "translate(28,15)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51851",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47877",
    transform: "translate(28,16)",
    style: {
      opacity: 0.992157,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51855",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47879",
    transform: "translate(28,17)",
    style: {
      opacity: 0.988235,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51859",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47881",
    transform: "translate(28,18)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51863",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47883",
    transform: "translate(28,19)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51867",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47885",
    transform: "translate(28,20)",
    style: {
      opacity: 0.980392,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51871",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47887",
    transform: "translate(28,21)",
    style: {
      opacity: 0.988235,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51875",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47889",
    transform: "translate(28,22)",
    style: {
      opacity: 0.980392,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51879",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47917",
    transform: "translate(29,9)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51903",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47919",
    transform: "translate(29,10)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51907",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47921",
    transform: "translate(29,11)",
    style: {
      opacity: 0.984314,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51911",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47923",
    transform: "translate(29,12)",
    style: {
      opacity: 0.992157,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51915",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47925",
    transform: "translate(29,13)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51919",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47927",
    transform: "translate(29,14)",
    style: {
      opacity: 0.984314,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51923",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47929",
    transform: "translate(29,15)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51927",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47931",
    transform: "translate(29,16)",
    style: {
      opacity: 0.992157,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51931",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47933",
    transform: "translate(29,17)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51935",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47935",
    transform: "translate(29,18)",
    style: {
      opacity: 0.988235,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51939",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47937",
    transform: "translate(29,19)",
    style: {
      opacity: 0.988235,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51943",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47939",
    transform: "translate(29,20)",
    style: {
      opacity: 0.494118,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51947",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47941",
    transform: "translate(29,21)",
    style: {
      opacity: 0.505882,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51951",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47969",
    transform: "translate(30,9)",
    style: {
      opacity: 0.992157,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51975",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47971",
    transform: "translate(30,10)",
    style: {
      opacity: 0.988235,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51979",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47973",
    transform: "translate(30,11)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51983",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47975",
    transform: "translate(30,12)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51987",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47977",
    transform: "translate(30,13)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51991",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47979",
    transform: "translate(30,14)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51995",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47981",
    transform: "translate(30,15)",
    style: {
      opacity: 0.988235,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect51999",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47983",
    transform: "translate(30,16)",
    style: {
      opacity: 0.992157,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect52003",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47985",
    transform: "translate(30,17)",
    style: {
      opacity: 0.984314,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect52007",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47987",
    transform: "translate(30,18)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect52011",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use47989",
    transform: "translate(30,19)",
    style: {
      opacity: 0.498039,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect52015",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use48009",
    transform: "translate(31,9)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect52023",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use48011",
    transform: "translate(31,10)",
    style: {
      opacity: 0.992157,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect52027",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use48013",
    transform: "translate(31,11)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect52031",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use48015",
    transform: "translate(31,12)",
    style: {
      opacity: 0.992157,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect52035",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use48017",
    transform: "translate(31,13)",
    style: {
      opacity: 0.980392,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect52039",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use48019",
    transform: "translate(31,14)",
    style: {
      opacity: 0.988235,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect52043",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use48021",
    transform: "translate(31,15)",
    style: {
      opacity: 0.992157,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect52047",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use48049",
    transform: "translate(32,9)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect52071",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use48051",
    transform: "translate(32,10)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect52075",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use48053",
    transform: "translate(32,11)",
    style: {
      opacity: 0.992157,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect52079",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use48055",
    transform: "translate(32,12)",
    style: {
      opacity: 0.996078,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect52083",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use48057",
    transform: "translate(32,13)",
    style: {
      opacity: 0.988235,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect52087",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use48059",
    transform: "translate(32,14)",
    style: {
      opacity: 0.988235,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect52091",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use48061",
    transform: "translate(32,15)",
    style: {
      opacity: 0.490196,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect52095",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use48087",
    transform: "translate(33,9)",
    style: {
      opacity: 0.988235,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect52115",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use48089",
    transform: "translate(33,10)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect52119",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use48091",
    transform: "translate(33,11)",
    style: {
      opacity: 0.992157,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect52123",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use48093",
    transform: "translate(33,12)",
    style: {
      opacity: 0.988235,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect52127",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use48095",
    transform: "translate(33,13)",
    style: {
      opacity: 0.992157,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect52131",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use48097",
    transform: "translate(33,14)",
    style: {
      opacity: 0.980392,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect52135",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use48125",
    transform: "translate(34,9)",
    style: {
      opacity: 0.980392,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect52159",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use48127",
    transform: "translate(34,10)",
    style: {
      opacity: 0.984314,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect52163",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use48129",
    transform: "translate(34,11)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect52167",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use48131",
    transform: "translate(34,12)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect52171",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use48133",
    transform: "translate(34,13)",
    style: {
      opacity: 0.988235,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect52175",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use48135",
    transform: "translate(34,14)",
    style: {
      opacity: 0.988235,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect52179",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use48161",
    transform: "translate(35,10)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect52199",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use48163",
    transform: "translate(35,11)",
    style: {
      opacity: 0.972549,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect52203",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use48165",
    transform: "translate(35,12)",
    style: {
      opacity: 0.992157,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect52207",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use48167",
    transform: "translate(35,13)",
    style: {
      opacity: 0.988235,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect52211",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use48169",
    transform: "translate(35,14)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect52215",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use48171",
    transform: "translate(35,15)",
    style: {
      opacity: 0.984314,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect52219",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use48173",
    transform: "translate(35,16)",
    style: {
      opacity: 0.490196,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect52223",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use48201",
    transform: "translate(36,11)",
    style: {
      opacity: 0.992157,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect52247",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use48203",
    transform: "translate(36,12)",
    style: {
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect52251",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use48205",
    transform: "translate(36,13)",
    style: {
      opacity: 0.984314,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect52255",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use48207",
    transform: "translate(36,14)",
    style: {
      opacity: 0.980392,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect52259",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use48209",
    transform: "translate(36,15)",
    style: {
      opacity: 0.988235,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect52263",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use48211",
    transform: "translate(36,16)",
    style: {
      opacity: 0.988235,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect52267",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "use48213",
    transform: "translate(36,17)",
    style: {
      opacity: 0.494118,
      fillOpacity: 1
    },
    "inkscapeTile-x0": 7,
    "inkscapeTile-y0": 7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect52271",
    width: 1,
    height: 1,
    x: 8,
    y: 8,
    style: {
      fillOpacity: 1
    }
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDodo);
export default __webpack_public_path__ + "static/media/dodo.68feefbc1c8b1e9bab5d0f099c6b2876.svg";
export { ForwardRef as ReactComponent };